import React from "react"
import "./default-layout.css"

export default ({ children }) => (
  <div className="default-layout">
    {children}
  </div>
)
